export default {"src":"/_next/static/media/meh.8d1ea3c3.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};